<!-- 客户需求分析详情 -->
<template>
  <div>
    <el-card style="margin-bottom: 20px;">
      <div class="title">
        <p>客户需求分析详情</p>
        <div>
          <el-select v-model="value1" placeholder="全部仓库" style="width: 160px;">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-date-picker v-model="value" type="daterange" align="right" unlink-panels range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
          </el-date-picker>
          <el-button type="primary" icon="el-icon-search" style="margin-left: 16px;width: 98px;">搜索</el-button>
          <el-button icon="el-icon-refresh-left" style="margin-left: 16px;width: 98px;">重置</el-button>
        </div>
      </div>
    </el-card>
    <matrix-statistics span="8" :list="statisticsList"></matrix-statistics>

    <el-card>
      <div class="title">
        <p>发货趋势分析</p>
      </div>
      <div id="trend"></div>
    </el-card>
    <el-row :gutter="20" style="margin-top: 20px;">
      <el-col :span="12">
        <el-card style="margin-bottom: 20px;">
          <div class="title">
            <p>月度发货规律</p>
          </div>
          <div id="law"></div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card style="margin-bottom: 20px;">
          <div class="title">
            <p>发货量分布</p>
          </div>
          <div id="bar"></div>
        </el-card>
      </el-col>
    </el-row>

    <div style="height: 80px;"></div>
  </div>
</template>
<script>
import matrixStatistics from '@/components/matrix/matrix-statistics'
import { getDefaultSearchTimeRange, getSearchTimePickerOptions } from '@/basic-common/util/common'
import * as echarts from 'echarts';

export default {
  name: "store-management/index/index",
  components: {
    matrixStatistics
  },
  data() {
    return {
      statisticsList: [{
        label: '区间内累计发货量',
        value: 123456,
        unit: '万吨',
      }, {
        label: '月均发货量',
        value: 987654,
        unit: '万吨',
      }, {
        label: '区间末库存量',
        value: 42156,
        unit: '万吨',
      }],
      value: getDefaultSearchTimeRange('daterange'),
      pickerOptions: getSearchTimePickerOptions('daterange'),
      value1: '',
      options: [{
        value: '选项1',
        label: '黄金糕'
      }, {
        value: '选项2',
        label: '双皮奶'
      }, {
        value: '选项3',
        label: '蚵仔煎'
      }, {
        value: '选项4',
        label: '龙须面'
      }, {
        value: '选项5',
        label: '北京烤鸭'
      }],
    };
  },
  mounted() {
    this.trendInit()
    this.lawInit()
    this.barInit()
  },
  methods: {
    trendInit() {
      let chartDom = document.getElementById('trend');
      let myChart = echarts.init(chartDom);
      let option = {
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
          splitLine: {
            lineStyle: {
              color: '#e0e6f1'
            }
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: '#e0e6f1'
            }
          }
        },
        series: [
          {
            data: [820, 932, 1101, 1234, 1290, 1330, 1320, 1101, 1234, 1290, 1330, 1320],
            type: 'line',
            smooth: true,
            lineStyle: {
              color: '#2563EB',
              width: 2,
            },
            itemStyle: {
              color: '#2563EB',
            },
          },
        ]
      };
      option && myChart.setOption(option);
    },
    lawInit() {
      let chartDom = document.getElementById('law');
      let myChart = echarts.init(chartDom);
      let option = {
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        radar: {
          indicator: [
            { name: '1月', max: 25000 },
            { name: '2月', max: 25000 },
            { name: '3月', max: 25000 },
            { name: '4月', max: 25000 },
            { name: '5月', max: 25000 },
            { name: '7月', max: 25000 },
            { name: '8月', max: 25000 },
            { name: '9月', max: 25000 },
            { name: '10月', max: 25000 },
            { name: '11月', max: 25000 },
            { name: '12月', max: 25000 },
          ]
        },
        series: [
          {
            type: 'radar',
            areaStyle: {
              show: true
            },
            data: [
              {
                value: [11453, 23891, 16742, 29480, 8765, 19523, 26789, 14567, 30245, 7321, 28124, 15678],
              },
            ]
          }
        ]
      };
      option && myChart.setOption(option);
    },
    barInit() {
      let chartDom = document.getElementById('bar');
      let myChart = echarts.init(chartDom);
      let option = {
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: ['<15', '15-20', '20-25', '25-30', '>30']
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
        },
        series: [
          {
            data: [12, 20, 50, 30, 20],
            color: '#2563EB',
            type: 'bar'
          }
        ]
      };
      option && myChart.setOption(option);
    }
  }
};
</script>
<style scoped lang="scss">
#trend,
#law,
#bar {
  width: 100%;
  height: 400px;
}

.title {
  display: flex;
  align-items: center;
  justify-content: space-between;

  p {
    color: #000000;
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
    margin: 0;
  }
}

::v-deep .el-input__icon {
  line-height: 1 !important;
}
</style>
